module.exports = __webpack_public_path__ + "static/media/300x250_0003_ro.23419501.jpg";